import classNames from 'classnames'
import * as React from 'react'

import './ModalContent.scss'

interface ModalContentProps {
  backgroundImage?: string
  children?: React.ReactNode | undefined
}

const ModalContent: React.FC<ModalContentProps> = ({
  backgroundImage,
  children,
}) => {
  const className = classNames(
    'modal-content',
    backgroundImage && 'background-image',
  )
  const url = backgroundImage ? `url(${backgroundImage})` : undefined
  return (
    <div
      className={className}
      style={backgroundImage ? { backgroundImage: url } : undefined}
    >
      {children}
    </div>
  )
}

export { ModalContent }
